import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Button,
  Table,
  Label,
  Spinner,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumb_2Items from "../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { postSubmitForm } from "../../../helpers/forms_helper";
import showNotification from "../../../helpers/show_notification";
import paginationFactory from "react-bootstrap-table2-paginator";
import preloader from "../../../helpers/preloader";
import calculatePrice from "../../../helpers/calculate_price";
import { formatUnitsForReport, GetUpdatedDelivered } from "../../../helpers/units";
import UpdateQuantityForPoModal from "../../../components/UpdateQuantityForPoModal";
import EnterQuantityForPoModal from "../../../components/EnterQuantityForPoModal";

const MainStoreRequisition = (props) => {
  
  const store_id = localStorage.getItem("store_id")
  const [cartItems, setCartItems] = useState([]);
  const [confirmDeatilsModal, setConfirmDeatilsModal] = useState(false)
  useEffect(() => {
    loadItems();
  }, []);


  const [selectedItems, setSelectedItems] = useState([]);
  const [selectUnitModal, setSelectUnitModal] = useState(false);
  const [editUnitModal, setEditUnitModal] = useState(false);
  const [filteredItems, setFilteredItems] = useState([]);


  const loadSuupliers = async (e) => {

    let url = process.env.REACT_APP_BASEURL + "suppliers/get_by_categories";
    let response = await postSubmitForm(url, {categories:[e.category]});
    if (response.status === 1) {
      const supplier = response.data.sort((a,b)=>a.name.localeCompare(b.name))
      const UpdatedWithSupplier = categorisezItem.map(item =>
        item.category === e.category
          ? { ...item, suppliers:supplier }
          : item
      );
      setCategorisezItem(UpdatedWithSupplier);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [searchkey, setSearchKey] = useState("");
  const [allItems, setAllItems] = useState([]);

  const loadItems = async () => {
    preloader(true);
    let url = process.env.REACT_APP_BASEURL + "items/get_mainstorewise_for_po";
    const response = await postSubmitForm(url, { store_id: store_id })
    if (response && response.status === 1) {
      const updatedItems = response.data?.filter((d)=>d.is_active).map((item) => ({
        ...item,
        total_price :0,
      }));
      const SortedData = updatedItems.sort((a,b)=>a.name.localeCompare(b.name))
      preloader(false);
      setAllItems(SortedData);
      setFilteredItems(SortedData);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };

  useEffect(() => {
    filterItems(allItems);
  }, [searchkey]);

  const filterItems = async (allItems) => {
    let filteredItems;
    if (!searchkey || searchkey.trim() === "") {
      filteredItems = allItems;
    } else {
      filteredItems = allItems?.filter((item) => {
        return (
          item.name.toLowerCase().includes(searchkey.toLowerCase()) ||
          item.category.toLowerCase().includes(searchkey.toLowerCase())
        );
      });
    }
    setFilteredItems(filteredItems);
  };

  const columns_items = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "item_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      editable: false,
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "45%" };
      },
      editable: false,
    },
    {
      text: props.t("Cat."),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
    },
    {
      text: props.t("Sub-Cat."),
      dataField: "sub_category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
    },
    {
      text: props.t("Brand"),
      dataField: "brand",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
    },
  ];

  const handleDeleteRow = (itemId) => {
    setCartItems((prevCartItems) => {
      const updatedCartItems = prevCartItems.filter((item) => item.item_id !== itemId);
      return updatedCartItems;
    });
  };
  

  const columns_cartitems = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "item_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      sort: false,
      footer: false,
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
      footer: false,
    },
    {
      text: props.t("Quantity"),
      dataField: "quantity",
      sort: false,
      editable: false,
      formatter: (cell, row) => {
        return (
          <>
            <div className="d-flex align-items-center justify-content-between">
              <span className="me-2">
                {formatUnitsForReport(row.quantity)}
              </span>
                <Button
                  className="btn btn-success btn-sm"
                  onClick={() => {
                    setSelectedItems(row)
                    setEditUnitModal(true);
                  }}
                >
                  <i class="mdi mdi-edit"></i>
                  {props.t("Edit")}
                </Button>
            </div>
          </>
        )
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },
    
    {
      text: props.t("Price"),
      dataField: "price",
      formatter:(cell,row)=>{
        return (row.price)+" / "+row.unit_for_po
      },
      sort: false,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },
    {
      text: props.t("Total"),
      dataField: "total_price",
      sort: false,
      formatter:(cell,row)=>{
        return row.total_price.toFixed(2)
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
      footer: (columnData) => {
        const total = columnData.reduce((acc, item) => acc + item, 0);
        return total.toFixed(2);
      },
    },
    {
      dataField: "",
      editable:false,
      text: "Remove",
      formatter: (cell, row) => {
        return (
          <span className="d-flex justify-content-center text-danger">
            <i
              className="bx bxs-trash font-size-20"
              title="Click to Remove"
              style={{ cursor: "pointer" }}
              onClick={() => {
               handleDeleteRow(row.item_id)
              }}
            ></i>
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      sort: false,
      footer: false,
    },
  ];

  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    hideSelectColumn: true,
    bgColor: '#ecf0a1',
    selected: cartItems.map(item => item.item_id),
    nonSelectable: cartItems
    .filter(cartItem => filteredItems.some(filterItem => filterItem.item_id === cartItem.item_id))
    .map(item => item.item_id),
    onSelect: (row, isSelect, rowIndex, e) => {
        if (isSelect) {
          setSelectedItems(row);
          SelectDefaultUnit(row);
          updateSelectedItems(row, isSelect);
        } else {
          e.preventDefault();
        }

    },
  };
  const [selectedRowsUnit, setSelectedRowsUnit] = useState([]);


  function SelectDefaultUnit(row) {
    setSelectedRowsUnit([
      {
        index: 0,
        unit: row.unit_levels[0].unit,
        formula: row.unit_levels[0].value,
        value: 0,
        isChecked: true,
      },
    ]);
    setSelectUnitModal(true);
  }

  function updateSelectedItems(row, isSelect) {
    setCartItems((prevSelected) => {
      if (isSelect) {
        if (!prevSelected.some(item => item.item_id === row.item_id)) {
          return [...prevSelected, row];
        }
      } else {
        const isnoUnitsSelected = selectedRowsUnit.every(unit => !unit.isChecked);
        if (isnoUnitsSelected) {
          return prevSelected.filter(item => item.item_id !== row.item_id);
        }
      }
      return prevSelected;
    });
  }

const [isSubmitting, setIsSubmitting] = useState(false)
  const handleSubmitRequisition = async () => {
   
    let payload = categorisezItem.map((category) => ({
      category: category.category,
      supplier:category.selSupp,
      items: category.items.map((item) => ({
        item_id: item.item_id,
        name: item.name,
        category: item.category,
        sub_category: item.sub_category,
        brand: item.brand,
        unit_for_po: item.unit_for_po,
        unit_levels:item.unit_levels.map(({unit,value})=>({unit,value})),
        quantity: item.quantity.map(({ unit, value }) => ({ unit, value })) || null, 
        unit_levels: item.unit_levels, 
        price: +item.price,
        total_price: Number(item.total_price.toFixed(2)),
              }))}))

              // console.log(payload);
  //  return
   
      try {
       if (categorisezItem.some((category) => category.selSupp === "")) {
          showNotification("Please select a supplier for each category", "Warning");
          return;
        }else if (
          categorisezItem.some((category) =>
            category.items.some((item) =>
              item.quantity.every(({ value }) => (value == "0" || value === ""|| value === 0))
            )
          )
        ) {
          showNotification("Please enter a valid quantity for atleast one unit", "Warning");
          return;
        }
        if (categorisezItem.length > 0) {
          setIsSubmitting(true);
          let url = process.env.REACT_APP_BASEURL + "mainstoreporequests/insert";
          // let data_to_send = { items: payload };
          // console.log(data_to_send);
          let response = await postSubmitForm(url, payload);
          if (response.status === 1) {
            const data = [];
            data.push(response.data)
            // console.log(data,"DAT");
            // for (let i = 0; i < data.length; i++) {
            //   window.open(
            //     `/purchase_order?po_id=${data[0]._id}`,
            //     "_blank"
            //   );
            // }
            showNotification(response.message, "Success");
            setCartItems([])
            setCategorisezItem([])
            setConfirmDeatilsModal(!confirmDeatilsModal)
            setSelectedItems([])
            setSelectedRowsUnit([])
           
            // window.location.reload();
          } else {
            showNotification(response.message, "Error");
          }
        } else {
          showNotification(
            "Please select at least one item and supplier.",
            "Error"
          );
        }
      } catch (error) {
        showNotification(error.message, "Error");
      } finally {
        setIsSubmitting(false);
      }
 
  };


const handleAddUnits = (qty) => {
  let convertedQuantity =  GetUpdatedDelivered(qty, selectedItems?.unit_levels)
  const updatedCartItems = cartItems.map(item => {
    if (item.item_id === selectedItems.item_id) {
      const total_price = calculatePrice(selectedItems.unit_levels,convertedQuantity, item.price,item.unit_for_po);
      return { ...item, quantity: convertedQuantity, total_price };
    } else {
      return item;
    }
  });

  setCartItems(updatedCartItems);
  setSelectUnitModal(false);
  setSelectedItems([]);
  setSelectedRowsUnit([]);
};

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );

  const pagination_options = {
    paginationSize: 100,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "All",
        value: allItems && allItems.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
    hideSizePerPage: true,
    ignoreSinglePage: true,
  };

  
const [categorisezItem, setCategorisezItem] = useState([])  

function groupBy(array, property) {
  return Object.values(array.reduce((acc, obj) => {
    const key = obj[property];
    if (!acc[key]) {
      acc[key] = { category: key, items: [],suppliers:[] ,selSupp:""};
    }
    acc[key].items.push(obj);
    return acc;
  }, {}));
}

useEffect(()=>{
  setCategorisezItem(()=>groupBy(cartItems,"category"))
},[cartItems])


  function handleCloseModal() {
    const hasValidquantity = selectedItems?.quantity && 
    selectedItems.quantity.every(unit => unit.value > 0);
  if (!hasValidquantity) {
    setCartItems((prevCartItems) =>
      prevCartItems.filter((item) => item.item_id !== selectedItems.item_id)
    );
  }
    setSelectUnitModal(false);
  }

  // const handlePriceChange = (e) => {
  //   const isItemInCart = cartItems.some(item => item.item_id === selectedItems.item_id);
  //   if (isItemInCart) {
  //     const updatedCartItems = cartItems.map(item =>
  //       item.item_id === selectedItems.item_id
  //         ? { ...item, price: +e.target.value }
  //         : item
  //     );
  //     setCartItems(updatedCartItems);
  //   }
  // }

  const handleSupplierSelection = (e,item) =>{
  const selectedSupplierName = e.target.value;
  setCategorisezItem((prevCategorisezItem) =>
    prevCategorisezItem.map((itm) =>
      itm.category === item.category
        ? { ...itm, selSupp: selectedSupplierName }
        : itm
    )
  );
  }

  const handleUpdateUnit = (qty) => {
    let convertedQuantity =  GetUpdatedDelivered(qty, selectedItems?.unit_levels)
    const isItemInCart = cartItems.some(item => item.item_id === selectedItems.item_id);
    if (isItemInCart) {
      const updatedCartItems = cartItems.map(item =>
        item.item_id === selectedItems.item_id
          ? {
              ...item,
              quantity: convertedQuantity,
              total_price: calculatePrice(item.unit_levels,convertedQuantity,item.price,item.unit_for_po),
            }
          : item
      );
      setCartItems(updatedCartItems);
      setEditUnitModal(false);
    } else {
      const newItem = {
        ...selectedItems,
        quantity: convertedQuantity,
        total_price: calculatePrice(selectedItems.unit_levels,convertedQuantity,selectedItems.price,selectedItems.unit_for_po),
      };
      setCartItems(prevCartItems => [...prevCartItems, newItem]);
      setEditUnitModal(false);
    }
  
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Main Store PO Request")}
            title={props.t("Procurement")}
            breadcrumbItem1={props.t("Main Store PO Request")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={6}>
                        <AvField
                          name="search"
                          label={props.t("Search")}
                          placeholder={props.t("Search items here")}
                          type="text"
                          onChange={(e) => {
                            e.preventDefault();
                            setSearchKey(e.target.value);
                          }}
                        ></AvField>
                      </Col>
                      <Col lg={6} className="d-flex justify-content-center align-items-center">
                      <div>
                        <Button
                          type="submit"
                          color="primary"
                          className="mx-auto"
                          onClick={() =>
                            setConfirmDeatilsModal(!confirmDeatilsModal)
                          }
                        >
                          {props.t("View Cart")}
                        </Button>
                      </div>
                      </Col>
                    </Row>
                    {/* <Button type="submit">Submit</Button> */}
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {/* <Row>
                    <Col lg={10}></Col>
                    <Col lg={2} className="text-center">
                      <div>
                        <Button
                          type="submit"
                          color="primary"
                          className="mb-2"
                          onClick={() =>
                            setConfirmDeatilsModal(!confirmDeatilsModal)
                          }
                        >
                          {props.t("View Cart")}
                        </Button>
                      </div>
                    </Col>
                  </Row> */}

                  <ToolkitProvider
                    bootstrap4
                    keyField="item_id"
                    data={filteredItems}
                    columns={columns_items}
                    noDataIndication={props.t("No data to display.")}
                    search
                  >
                    {(props) => (
                      <div>
                        <BootstrapTable
                          pagination={paginationFactory(pagination_options)}
                          striped
                          hover
                          condensed
                          selectRow={selectRow}
                          {...props.baseProps}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Review deatils  */}

          <Modal
            size="lg"
            isOpen={confirmDeatilsModal}
            toggle={() => setConfirmDeatilsModal(!confirmDeatilsModal)}
          >
            <ModalHeader
              toggle={() => setConfirmDeatilsModal(!confirmDeatilsModal)}
            >
              {props.t("Review Order Details")}
            </ModalHeader>
            <ModalBody>
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={12}>
                      <Row>
                        <Col lg={12}>
                          {categorisezItem && categorisezItem.map((item)=>{
                            if(item.items.length>0){
                              return (
                                <>
                                 <Row>
                            <Col lg={8}>
                              <Label>{props.t("Category")}: {item.category}</Label>
                            </Col>
                            <Col lg={4}>
                              <AvForm>
                                <AvField
                                  name="supplier"
                                  type="select"
                                  value={item.selSupp||""}
                                  onClick={()=>loadSuupliers(item)}
                                  onChange={(e)=>handleSupplierSelection(e,item)}
                                >
                                  <option value="">
                                    {props.t("--Select Supplier--")}
                                  </option>
                                  {item.suppliers &&
                                    item.suppliers.map((e) => (
                                      <option
                                        key={e.value}
                                        value={e.value}
                                        name={e.value}
                                      >
                                        {e.name}
                                      </option>
                                    ))}
                                </AvField>
                              </AvForm>

                                  {/* <Select
                                  options={item.suppliers}
                                  value={item.selSupp||""}
                                  onMenuOpen={()=>loadSuupliers(item)}
                                  onChange={(e)=>handleSupplierSelection(e,item)}
                                  closeMenuOnSelect={true}
                                  classNamePrefix="select"
                                  // isMulti={selectMore}
                                  // menuisOpen={true}
                                  required
                                  // className="basic-multi-select"
                                /> */}
                           
                            </Col>
                          </Row>
                                <ToolkitProvider
                                bootstrap4
                                keyField="item_id"
                                data={item.items}
                                columns={columns_cartitems}
                                noDataIndication={props.t("No data to display.")}
                                search
                              >
                                {(props) => (
                                  <div>
                                    <BootstrapTable
                                      striped
                                      hover
                                      condensed
                                      cellEdit={cellEditFactory({
                                        mode: "click",
                                        blurToSave: true,
                                        afterSaveCell: (
                                          oldValue,
                                          newValue,
                                          row,
                                          column
                                        ) => {
                                          
                                          // console.log(row.price, row.quantity);
                                        },
                                      })}
                                      {...props.baseProps}
                                    />
                                  </div>
                                )}
                              </ToolkitProvider>
                                </>
                              )
                            }
                          })}
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={12}>
                      <FormGroup className="mb-0 text-center">
                        <div>
                          <Button
                            type="submit"
                            color="primary"
                            className="mr-1"
                            style={{width:"100px"}}
                            disabled={isSubmitting}
                            onClick={handleSubmitRequisition}
                          >
                          {isSubmitting ? <Spinner size="sm" /> : props.t("Submit")} 
                          </Button>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </ModalBody>
          </Modal>

          {/* Add unit modal  */}
          <EnterQuantityForPoModal 
          isOpen={selectUnitModal}
          toggle={handleCloseModal}
          onSubmit={handleAddUnits}
          item={selectedItems}
          selectedUnits={selectedRowsUnit}
          cartItems={cartItems}
          setCartItems={setCartItems}
          selectedItems={selectedItems}
          />
          {/* <Modal
            size="md"
            isOpen={selectUnitModal}
            toggle={handleCloseModal}
            onClosed={handleCloseModal}
          >
            <ModalHeader toggle={() => setSelectUnitModal(!selectUnitModal)}>
              {props.t("Enter Quantity")}
            </ModalHeader>
            <ModalBody>
              <AvForm onValidSubmit={()=>{handleAddUnits()}}>
                <Col lg={12}>
                  <Table bordered size="sm" responsive className="table table-sm">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>{props.t("Unit")}</th>
                          <th>{props.t("Quantity")}</th>
                          <th>{props.t("formula")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedItems.unit_levels &&
                        selectedItems.unit_levels?.map((unitObj, index) => {
                          let prevUnit = index;
                          if (index == 0) {
                            prevUnit = "NA";
                          } else
                            prevUnit =
                              selectedItems?.unit_levels[index - 1].unit;
                          return (
                            <tr key={index} >
                              <td>
                                <div class="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    checked={selectedRowsUnit.some(
                                      (row) =>
                                        row.index === index && row.isChecked
                                    )}
                                    id={`flexCheckDefault_${index}`}
                                    onChange={() => handleCheckboxChange(index, selectedItems,setSelectedRowsUnit)}
                                  />
                                </div>
                              </td>
                              <td onClick={()=>handleCheckboxChange(index, selectedItems,setSelectedRowsUnit)}>
                                {unitObj.unit}</td>
                              <td>
                                <AvField
                                  type="number"
                                  className="form-control"
                                  style={{ width: "60px", height: "20px" }}
                                  placeholder="0"
                                  name={unitObj.unit}
                                  validate={{
                                    required: { value: selectedRowsUnit.some(row => row.index === index && row.isChecked) },
                                     pattern: {
                                      value: "^[0-9]+$",
                                      errorMessage: props.t("Only whole numbers are allowed"),
                                    },
                                    min: { value: selectedRowsUnit.some(row => row.index === index && row.isChecked) ? 1 : 0 }
                                  }}
                                  errorMessage={props.t("Qty. can't be empty")}
                                  disabled={!selectedRowsUnit.some(row => row.index === index && row.isChecked)}
                                  value={
                                    selectedRowsUnit.find(
                                      (row) => row.index === index
                                    )?.value
                                  }
                                  onChange={(e) => {
                                    const quantity = e.target.value;
                                    handleQuantityChange(index, quantity,setSelectedRowsUnit);
                                  }}
                                />
                              </td>
                              <td>
                                {index > 0
                                  ? "1" +
                                  "  " +
                                  prevUnit +
                                  " = " +
                                  unitObj.value +
                                  " " +
                                  unitObj.unit
                                  : "NA"}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                </Col>
                <Row>
                  <Col lg={4} md={4} sm={4} className="d-flex justify-content-end">
                    {props.t("Price")}
                  </Col>
                  <Col lg={4} md={4} sm={4}>
                    <AvField
                      type="number"
                      name="price"
                      value={selectedItems?.price}
                      className="form-control"
                      onChange={(e) => handlePriceChange(e)}
                      style={{ height: "20px" }}
                       validate={{
                        required: { value: true, errorMessage: props.t("Price is required") },
                        min: {
                          value: 0.1,
                          errorMessage: props.t("Value must be greater than or equal to 0.1"),
                        },
                      }}
                      errorMessage={props.t("Price is required")}
                    />
                  </Col>
                  <Col lg={4} md={4} sm={4}>
                    / {selectedItems?.unit_for_po}
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col lg={12}>
                    <FormGroup className="mb-0 text-center">
                      <div>
                        <Button
                          type="submit"
                          color="primary"
                          className="mr-1"
                        >
                          {props.t("Add")}
                        </Button>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </AvForm>
            </ModalBody>
          </Modal> */}

          {/* Edit Units Modal  */}
          <UpdateQuantityForPoModal 
          isOpen={editUnitModal}
          toggle={()=>setEditUnitModal(false)}
          onSubmit={handleUpdateUnit}
          item={selectedItems}
          selectedUnits={selectedRowsUnit}
          cartItems={cartItems}
          setCartItems={setCartItems}
          selectedItems={selectedItems}
          />
          {/* <Modal
            size="md"
            isOpen={editUnitModal}
            toggle={() => setEditUnitModal(!editUnitModal)}
          >
            <ModalHeader toggle={() => setEditUnitModal(!editUnitModal)}>
              {props.t("Edit Units and Quantity")}
            </ModalHeader>
            <ModalBody>
   
            <AvForm >
            <Col lg={12}>
                  <Table bordered size="sm" responsive className="table table-sm">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>{props.t("Unit")}</th>
                          <th>{props.t("Quantity")}</th>
                          <th>{props.t("formula")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedItems &&
                          selectedItems.unit_levels?.map((unitObj, index) => {
                            let prevUnit;
                            if (index == 0) {
                              prevUnit = "NA";
                            } else
                              prevUnit =
                                selectedItems?.unit_levels[index - 1].unit;
                                const selectedUnit = selectedItems?.quantity?.find(
                                  (su) => su.unit === unitObj.unit
                                );
                            return (
                              <tr key={index}>
                                <td>
                                  <div class="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value=""
                                      checked={selectedUnit?.isChecked}
                                      onChange={() =>
                                        handleCheckboxUpdate(index,unitObj,setSelectedItems)
                                      }
                                    />
                                  </div>
                                </td>
                                <td> {unitObj.unit}</td>
                                <td>
                                  <AvField
                                    type="number"
                                    placeholder="0"
                                    className="form-control"
                                    disabled={selectedUnit?.isChecked ? false : true}
                                    style={{ width: "50px", height: "20px" }}
                                    name={unitObj.unit}                          
                                    value={selectedUnit ? selectedUnit.value : ''}                          
                                    validate={{
                                      required:{value:selectedUnit?.isChecked ?true :false},
                                       pattern: {
                                      value: "^[0-9]+$",
                                      errorMessage: props.t("Only whole numbers are allowed"),
                                    },
                                      min: { value: 1, errorMessage: 'can not be zero' },
                                    }}
                                    errorMessage={props.t("Qty. can't be empty")}
                                    onChange={(e) => {
                                      const quantity = e.target.value;
                                      handleQuantityUpdate(index, quantity,unitObj.unit, setSelectedItems);
                                    }}
                                  />
                                </td>
                                <td>
                                  {index > 0
                                    ? "1" + "  " + prevUnit + " = " + unitObj.value +" " + unitObj.unit
                                    : "NA"}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </Table>
                  </Col>
                  <Row>
                    <Col lg={4} md={4} sm={4}className="d-flex justify-content-end">
                      <div> {props.t("Price")}</div>
                    </Col>
                    <Col lg={4} md={4}>
                      <AvField
                        type="number"
                        name="price"
                        value={selectedItems?.price}
                        className="form-control"
                        onChange={(e) => handlePriceChange(e)}
                        style={{ height: "20px" }}
                         validate={{
                        required: { value: true, errorMessage: props.t("Price is required") },
                        min: {
                          value: 0.1,
                          errorMessage: props.t("Value must be greater than or equal to 0.1"),
                        },
                      }}  
                        errorMessage={props.t("Price is required")}
                      />
                    </Col>
                    <Col lg={4} md={4}>
                      / {selectedItems?.unit_for_po}
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col lg={12}>
                      <FormGroup className="mb-0 text-center">
                        <div>
                          <Button
                            type="submit"
                            color="primary"
                            className="mr-1"
                            onClick={()=>handleUpdateUnit()}
                          >
                            {props.t("Add")}
                          </Button>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
            </AvForm>
            </ModalBody>
          </Modal> */}
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(MainStoreRequisition))
);
